import { useTranslation } from "react-i18next";

const items = [
  { icon: "ri-layout-grid-line", titleKey: "why.c1title", descKey: "why.c1desc" },
  { icon: "ri-search-eye-line", titleKey: "why.c2title", descKey: "why.c2desc" },
  { icon: "ri-scales-3-line", titleKey: "why.c3title", descKey: "why.c3desc" },
  { icon: "ri-shield-check-line", titleKey: "why.c4title", descKey: "why.c4desc" },
];

export default function WhySection() {
  const { t } = useTranslation();

  return (
    <section className="relative bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <div className="text-center">
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            {t("why.title")}
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-sm text-foreground-600 md:text-base">
            {t("why.subtitle")}
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {items.map((item, i) => (
            <div
              key={item.titleKey}
              className={`rounded-lg border p-5 md:p-6 ${
                i === 3 ? "border-accent-200 bg-accent-50" : "border-background-200 bg-background-50"
              }`}
            >
              <span
                className={`flex h-11 w-11 items-center justify-center rounded-lg ${
                  i === 3 ? "bg-accent-500 text-background-50" : "bg-primary-100 text-primary-700"
                }`}
              >
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950 md:text-lg">
                {t(item.titleKey)}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{t(item.descKey)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}